import React, {Component} from 'react';
import { getCSS } from './CrossSellGalleryElementStyles';
import InlineStyle from 'crazyEditor/components/Elements/common/InlineStyle';
import { chevronRight, chevronLeft } from 'shared/icons';
import _ from 'lodash';
import {buildInteractiveElementsList} from 'crazyEditor/core/elements/utils/commonElementMethods';
import {findDOMNode} from 'react-dom';
import CrossSellGalleryElementMetaData from './CrossSellGalleryElementMetaData';
import { getElementFontSize } from 'crazyEditor/core/elements/utils/commonElementMethods';

require('./GlobalStyles/CrossSellGalleryElement.scss');

export const crossSellGalleryBaseStyle = {
  paddingTop: 20,
  paddingBottom: 30,
};

export const MAX_NUM_OF_ITEMS = 25;
const HEADER_AND_NAME_FONT_SIZE_MULTIPLIER = 1.4;
const PRICE_FONT_SIZE_MULTIPLIER = 1.7;

export default class CrossSellGallery extends Component {
  componentWillMount() {
    const {id} = this.props;
    if (id) {
      this.uniqueId = `cross-sell-gallery-${id}`;
    } else {
      this.uniqueId = _.uniqueId('cross-sell-gallery-');
    }
  }

  componentDidMount() {
    this.refreshInteractiveElementsList();
  }

  getInteractiveElements = () => {
    return this.interactiveElements;
  };

  getCrossSellGalleryComponents() {
    const {compProps, crossSellItemsData} = this.props.data;
    const headerAndNameSize = this.getFontSize(HEADER_AND_NAME_FONT_SIZE_MULTIPLIER);
    const priceSize = this.getFontSize(PRICE_FONT_SIZE_MULTIPLIER);
    const inputList = [];
    const imageList = [];
    const rightArrowList = [];
    const leftArrowList = [];
    const desktopItemsDescriptionList = [];
    const mobileItemsDescriptionList = [];
    const itemDescriptionPlaceholder = (
      <div className="cross-sell-gallery-item-description" style={{position: 'relative'}}>
        <p id="cross-sell-gallery-price-placeholder" style={{margin: 0, marginTop: 20, ...compProps, fontSize: priceSize, fontWeight: 'bold'}}/>
        <p id="cross-sell-gallery-name-placeholder" style={{margin: 0, marginTop: 10, ...compProps, fontSize: headerAndNameSize}}/>
        <p id="cross-sell-gallery-ends-in-placeholder" style={{margin: 0, marginTop: 10, ...compProps}} />
      </div>
    );
    const gallerySize = _.size(crossSellItemsData) === 0 ? MAX_NUM_OF_ITEMS : _.size(crossSellItemsData);
    for (let i = 0; i < gallerySize; i++) {
      const url = !_.isEmpty(crossSellItemsData) ? crossSellItemsData[i].url : undefined;
      const inputUniqueId = `${this.uniqueId}-input`;
      const imageUniqueId = `${this.uniqueId}-image`;
      const itemNameUniqueId = `${this.uniqueId}-item-name`;
      const itemPriceUniqueId = `${this.uniqueId}-item-price`;
      const itemEndsInUniqueId = `${this.uniqueId}-item-ends-in`;
      inputList.push(<input id={`${inputUniqueId}_${i}`}
                            type="radio"
                            name={`${inputUniqueId}`}
                            className="cross-sell-gallery-input"
                            defaultChecked={i === 0} />);
      imageList.push(
        <a href={url} className="cross-sell-gallery-link" target="_blank">
          <div id={'cross-sell-gallery-image-wrapper' + i} className={`cross-sell-gallery-image-wrapper cross-sell-gallery-image-wrapper${i}`}>
            <div style={{paddingBottom: '100%'}} />
            <div id={`${imageUniqueId}${i}`} className="cross-sell-gallery-image" />
          </div>
        </a>);
      rightArrowList.push(
        <label id={`cross-sell-gallery-right-arrow-wrapper${i}`}
               className="cross-sell-gallery-arrow-wrapper cross-sell-gallery-right-arrow-wrapper"
               htmlFor={`${inputUniqueId}_${i}`}>
          <svg className="cross-sell-gallery-arrow cross-sell-gallery-right-arrow" viewBox="0 0 24 24">
            <path fill="#888"
                  stroke="#ffffff"
                  d={chevronRight} />
          </svg>
        </label>);
      leftArrowList.push(
        <label id={`cross-sell-gallery-left-arrow-wrapper${i}`}
               className="cross-sell-gallery-arrow-wrapper cross-sell-gallery-left-arrow-wrapper"
               htmlFor={`${inputUniqueId}_${i}`}>
          <svg className="cross-sell-gallery-arrow cross-sell-gallery-left-arrow" viewBox="0 0 24 24">
            <path fill="#888"
                  stroke="#ffffff"
                  d={chevronLeft} />
          </svg>
        </label>);
      desktopItemsDescriptionList.push(
        <a href={url} className="cross-sell-gallery-link" target="_blank">
          <div id={'cross-sell-gallery-item-description' + i} className="cross-sell-gallery-item-description">
            <p id={`${itemPriceUniqueId}${i}`} style={{margin: 0, marginTop: 20, ...compProps, fontSize: priceSize, fontWeight: 'bold'}} />
            <p id={`${itemNameUniqueId}${i}`} style={{margin: 0, marginTop: 10, ...compProps, fontSize: headerAndNameSize}} />
            <p id={`${itemEndsInUniqueId}${i}`} style={{margin: 0, marginTop: 10, ...compProps}} />
          </div>
        </a>
      );
      mobileItemsDescriptionList.push(
        <a href={url} className="cross-sell-gallery-link" target="_blank">
          <div id={'mobile-cross-sell-gallery-item-description' + i} className="cross-sell-gallery-item-description mobile-cross-sell-gallery-item-description">
            <p id={`mobile-${itemPriceUniqueId}${i}`} style={{margin: 0, marginTop: 20, ...compProps, fontSize: priceSize, fontWeight: 'bold'}} />
            <p id={`mobile-${itemNameUniqueId}${i}`} style={{margin: 0, marginTop: 10, ...compProps, fontSize: headerAndNameSize}} />
            <p id={`mobile-${itemEndsInUniqueId}${i}`} style={{margin: 0, marginTop: 10, ...compProps}} />
          </div>
        </a>
      );
    }
    return {inputList, imageList, rightArrowList, leftArrowList, desktopItemsDescriptionList, mobileItemsDescriptionList, itemDescriptionPlaceholder};
  }

  getFontSize = (multiplier) => {
    const {value, unit} = getElementFontSize(this.props);
    return unit ? value * multiplier + unit : value * multiplier;
  };

  getItemsIds = () => {
    const {crossSellItemsData} = this.props.data;
    return _.map(crossSellItemsData, (itemData) => {
      return itemData.id;
    });
  };

  refreshInteractiveElementsList = (onComplete) => {
    this.lastOnComplete = onComplete;
    let interactiveElements = [];
    const wrapper = findDOMNode(this.refs.rootElement);
    if (wrapper) {
      interactiveElements = buildInteractiveElementsList(wrapper);
      if (interactiveElements.length > 0) {
        this.interactiveElements = interactiveElements;
        if (onComplete) {
          onComplete();
        }
      }
    }
  };

  handleLinkRef = (ref) => {
    const link = findDOMNode(ref);
    if (link) {
      link.addEventListener('load', () => {
        this.refreshInteractiveElementsList(this.lastOnComplete);
      });
    }
  };

  render() {
    const {type, placeholderGallery} = this.props;
    const desktopCrossSellGallery = type === CrossSellGalleryElementMetaData.type;
    const {compProps, sellerId, globalId, baseUrl, listingData, crossSellItemsData} = this.props.data;
    let itemId = 'CL_ITEM_ID';
    if (listingData && listingData.itemID) {
      itemId = listingData.itemID;
    }
    const itemsIds = this.getItemsIds();
    const {inputList, imageList, rightArrowList, leftArrowList, desktopItemsDescriptionList, mobileItemsDescriptionList, itemDescriptionPlaceholder} = this.getCrossSellGalleryComponents();
    const getImagesURL = baseUrl + `/listing-assets/new-crazy-gallery.css?itemId=${itemId}&sellerId=${sellerId}&globalId=${globalId}&itemsIds=${JSON.stringify(itemsIds)}&uniqueId=${this.uniqueId}`;
    return (
      <div style={{position: 'relative'}} ref="rootElement">
        <InlineStyle css={getCSS(this.uniqueId, sellerId ? true : false, placeholderGallery)}/>
        <div>
          { !_.isEmpty(crossSellItemsData) && <link key={sellerId + globalId} ref={this.handleLinkRef} href={getImagesURL} media="screen" rel="stylesheet" type="text/css"/> }
          <p style={{margin: 0, paddingBottom: 20, ...compProps, fontSize: this.getFontSize(HEADER_AND_NAME_FONT_SIZE_MULTIPLIER)}}>
            See our other items
          </p>
          {inputList}
          {desktopCrossSellGallery &&
          <div id="cross-sell-gallery-wrapper" className="cross-sell-gallery-wrapper" style={{position: 'relative'}}>
            <div style={{paddingBottom: '20%'}} />
            <div style={{top: 0, bottom: 0, left: 0, right: 0, position: 'absolute'}}>
              {imageList}
              {rightArrowList}
              {leftArrowList}
            </div>
          </div>}
          {!desktopCrossSellGallery &&
          <div id="mobile-cross-sell-gallery-wrapper" className="mobile-cross-sell-gallery-wrapper" style={{position: 'relative'}}>
            <div style={{paddingBottom: '100%'}} />
            <div style={{top: 0, bottom: 0, left: 0, right: 0, position: 'absolute'}}>
              {imageList}
              {rightArrowList}
              {leftArrowList}
            </div>
          </div>}
          {desktopCrossSellGallery && desktopItemsDescriptionList}
          {!desktopCrossSellGallery && mobileItemsDescriptionList}
          {itemDescriptionPlaceholder}
        </div>
      </div>
    );
  }
}
